/*
 * @Author: Json Chen
 * @Date: 2021-07-14 17:17:41
 * @LastEditTime: 2021-07-14 17:50:04
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PickupLocations/Components/DatePickerRangePickerList.tsx
 */
import { SizeFittingTable } from '@/src/components/Antd';
import { DatePicker } from 'antd';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { randomNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';

import styles from '../../style.module.less';
const DatePickerRangePickerList = ({ value: list = [], onChange }: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const onDelClick = (index) => {
    onChange((list || []).filter((_, i) => i !== index));
  };
  const onRangeChange = (value) => {
    if (value.length === 2) {
      onChange((list || []).concat([value.map((v) => v.format('YYYY-MM-DD'))]));
    }
  };
  const columns = [
    {
      title: getI18n('storeLogistics.pickupLocations.blockoutdate'),
      default: true,
      dataIndex: 'index',
      width: 992,
      childGenerate: (text, record) => {
        const times = record.time.map((d) => moment(d));
        let rangeText = '';

        if (times[0].isSame(times[1])) {
          rangeText = times[0].format('DD MMMM YYYY');
        } else {
          rangeText = times.map((v) => v.format('DD MMMM YYYY')).join(' - ');
        }
        return <div>{rangeText}</div>;
      },
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      default: true,
      optional: true,
      align: 'center',
      width: 126,
      childGenerate: (_, record, index) => {
        return (
          <div className={styles.action}>
            <span className={styles.danger} onClick={() => onDelClick(index)}>
              {getI18n('general.delete')}
            </span>
          </div>
        );
      },
    },
  ];

  const tableList = useMemo(() => {
    return (list || []).map((item) => ({
      index: randomNumber(),
      time: item,
    }));
  }, [list]);

  const disabledDate = (current) => {
    return current && current < moment().endOf('day');
  };
  return (
    <React.Fragment>
      <DatePicker.RangePicker
        getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
        size='large'
        className={styles.specificDatePicker}
        allowClear={false}
        value={[] as any}
        onChange={onRangeChange}
        disabledDate={disabledDate}
      />
      {tableList.length ? (
        <SizeFittingTable
          id='PickupDateRanges'
          rowKey={'index'}
          pagination={false}
          dataSource={tableList}
          columns={columns}
        />
      ) : null}
    </React.Fragment>
  );
};

export default DatePickerRangePickerList;
